import {Component, OnDestroy, OnInit} from '@angular/core';
import {SpThemingService} from '../../../../services/sp-theming/sp-theming.service';
import { MatDialog } from '@angular/material/dialog';
import {Message} from 'primeng/api';
import {
  AudienceCreationMode,
  AudienceType,
  ProjectCreationManagerService,
  TargetingType
} from '../../../../services/sp-project/project-creation-manager.service';
import {LoggerService} from '../../../../services/sp-logger/logger.service';
import {environment} from '../../../../../environments/environment';
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';
import { Router } from '@angular/router';
import { Targeting } from 'src/app/classes/targeting/targeting';

@Component({
  selector: 'app-sp-project-create-facebook-interest',
  templateUrl: './sp-project-create-facebook-interest.component.html',
  styleUrls: ['./sp-project-create-facebook-interest.component.scss']
})
export class SpProjectCreateFacebookInterestComponent implements OnInit, OnDestroy {
  // Notifications
  msgs: Message[] = [];
  showPresetSelection = false;

  // Constructor.
  constructor(private _spTheming: SpThemingService,
              private sessionProvider: SessionProviderService,
              public creationManager: ProjectCreationManagerService,
              private dialog: MatDialog,
              private logger: LoggerService,
              private router: Router) {
    // Set the theme to use.
    this._spTheming.setSpThemeName('dashboard-desk');
    creationManager.reset(AudienceType.target, AudienceCreationMode.interest);
    creationManager.switchAudienceType(AudienceType.target);
    creationManager.switchAudienceMode(AudienceCreationMode.interest);

    // Check if AI-generated audience was passed via router state.
    // Router state goes through structured clone, which strips class prototypes,
    // so we receive the FB JSON spec as a string and rebuild a real Targeting instance.
    const navigation = this.router.getCurrentNavigation();
    const aiGeneratedAudienceSpec = navigation?.extras?.state?.['aiGeneratedAudienceSpec'] as string;
    const aiGeneratedAudienceType = (navigation?.extras?.state?.['aiGeneratedAudienceType'] as string) ?? 'sociodemo';
    const aiGeneratedAudienceName = navigation?.extras?.state?.['aiGeneratedAudienceName'] as string;

    if (aiGeneratedAudienceSpec) {
      // Clear existing geolocations first to prevent default "Worldwide" from persisting
      this.creationManager.resetGeolocation(TargetingType.INCLUSION, AudienceType.target);
      this.creationManager.resetGeolocation(TargetingType.EXCLUSION, AudienceType.target);

      // Rebuild a real Targeting instance from the serialized spec
      const aiGeneratedAudience = Targeting.fromJson(aiGeneratedAudienceSpec, aiGeneratedAudienceType);

      // Set the AI-generated targeting
      this.creationManager.audienceTarget.targeting = aiGeneratedAudience;
      creationManager.loadAudienceInfoFromTargeting(aiGeneratedAudience, AudienceType.target);

      // Set the AI-generated project name
      this.creationManager.changeProjectName(aiGeneratedAudienceName, true);

      // Mark that we have AI-generated geolocations to prevent override by default universe
      (this.creationManager as any)._hasAiGeneratedGeolocations = true;

      // Load default benchmark
      const audienceBenchmarkSpec = this.creationManager.audienceBenchmark.targeting;
      creationManager.loadAudienceInfoFromTargeting(audienceBenchmarkSpec, AudienceType.benchmark);
    } else {
      // Standard flow - load from current state
      const audienceTargetSpec = this.creationManager.audienceTarget.targeting;
      const audienceBenchmarkSpec = this.creationManager.audienceBenchmark.targeting;
      creationManager.loadAudienceInfoFromTargeting(audienceTargetSpec, AudienceType.target);
      creationManager.loadAudienceInfoFromTargeting(audienceBenchmarkSpec, AudienceType.benchmark);
    }
  }
  // On init.
  async ngOnInit() {
    this.scrollToTop();
    this.showPresetSelection = await this.sessionProvider.activeSession?.hasPermission('audience.library.access') ?? false;
  }
  ngOnDestroy() {
  }
  scrollToTop() {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
  }
  showError(errorName: string) {
    this.logger.logError(errorName);
    this.msgs = [];
    this.msgs.push({severity:'error', summary:'Error Message', detail: errorName});
  }

  protected readonly environment = environment;
}
